import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  Alert,
  AlertIcon,
  Box,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";
import { useRecoilState } from "recoil";
import { customColors } from "../../../../atoms/customColors";

interface ModalConfirmCancelLoteProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onConfirm: () => void;
  batchId: string;
  /** parcelas já emitidas do lote — as que continuam válidas depois do cancelamento */
  emitidas?: number;
  /** total de parcelas do carnê */
  total?: number;
}

export default function ModalConfirmCancelLote({
  isOpen,
  setIsOpen,
  onConfirm,
  batchId,
  emitidas,
  total,
}: ModalConfirmCancelLoteProps) {
  const [colors] = useRecoilState(customColors);

  const jaEmitidos = emitidas ?? 0;
  const naFila = Math.max(0, (total ?? 0) - jaEmitidos);

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Confirmar Cancelamento do Lote</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {/* O nome "cancelar" promete mais do que a ação faz: quem lê entende
              que os boletos deixam de valer. Não deixam — título emitido já
              está registrado no banco e o pagador consegue pagar. Por isso o
              modal separa, em texto, o que acontece do que NÃO acontece. */}
          <Text mb={3}>
            Cancelar o lote <b>{batchId}</b>:
          </Text>

          <UnorderedList spacing={2} fontSize="sm" mb={4}>
            <ListItem>
              <b>Encerra a fila de emissão.</b>
              {naFila > 0
                ? ` As ${naFila} parcela(s) que ainda não foram emitidas são removidas do carnê.`
                : " As parcelas que ainda não foram emitidas são removidas do carnê."}
            </ListItem>
            <ListItem>
              <b>Marca o carnê como cancelado</b> nas suas telas — é um controle
              seu, para o lote não continuar aparecendo como ativo.
            </ListItem>
          </UnorderedList>

          <Alert status="warning" borderRadius="md" fontSize="sm">
            <AlertIcon />
            <Box>
              <Text fontWeight="bold">
                Os boletos já emitidos continuam válidos.
              </Text>
              <Text>
                {jaEmitidos > 0
                  ? `Os ${jaEmitidos} boleto(s) já gerado(s) seguem registrados no banco e o pagador ainda consegue pagá-los.`
                  : "Boleto já gerado segue registrado no banco e o pagador ainda consegue pagá-lo."}{" "}
                Este cancelamento não dá baixa nem invalida cobrança emitida —
                para isso, fale com o suporte.
              </Text>
            </Box>
          </Alert>

          <Text mt={3} fontSize="sm" color="gray.600">
            Esta ação não pode ser desfeita.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="outline"
            colorScheme="gray"
            mr={3}
            onClick={() => setIsOpen(false)}
          >
            Cancelar
          </Button>
          <Button
            bgColor={colors.REDMONEDD}
            color={colors.WHITE}
            onClick={() => {
              onConfirm();
              setIsOpen(false);
            }}
            _hover={{ bgColor: colors.REDCARD }}
          >
            Confirmar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
